var lib_core      = require("lib-core");
var THREE         = require("three");

var PositionHandleModel  = require("./../abstract/positionHandleModel.js");

var VertHandleModel = function (editorModel, handleId, config) {
    PositionHandleModel.call(this, editorModel, handleId);
};

lib_core.inherit(VertHandleModel, PositionHandleModel);
VertHandleModel.$class = "VertHandleModel";
module.exports = VertHandleModel;

VertHandleModel.prototype.getSubjectsRotation = function(){
    return this.getSubject().getRotation();
} 

VertHandleModel.prototype.released = function(){
    this.selected(false);
}

VertHandleModel.prototype.setContactPosition = function(position){
    this.startPosition = position;
    this.selected(true);

    var subject = this.getSubject();
    var basePos = subject.getPosition();
    this.contactOffset = this.startPosition.sub(basePos);
}


VertHandleModel.prototype.createMovementPlane = function(ray, point){
    var newRay = new THREE.Vector3(ray.direction.x, ray.direction.y, 0);
    newRay.normalize();

    var zero = new THREE.Vector3();
    var subject = this.getSubject();
    var vecToOrigin = subject.getPosition().toThreejs();

    var distanceToOrigin = zero.distanceTo(vecToOrigin);
    vecToOrigin.normalize();
    var dotProduct = vecToOrigin.dot(newRay);
    var angle = Math.acos(dotProduct);
    var adjLength = distanceToOrigin * Math.cos(angle);
    this.movementPlane.setComponents(newRay.x, newRay.y, newRay.z, -adjLength);
}

VertHandleModel.prototype.setMousePosition = function(position){

    var subject = this.getSubject();
    var basePos = subject.getPosition();

    subject.setZ(position.sub(this.contactOffset).z);
}


